import * as React from 'react';

import { Select } from 'components';
import { zPositions } from '@/constants';

type ContactImportanceType = 'Primary' | '2nd' | '3rd' | 'Other';

export type ContactImportanceSelectProps = {
  value: ContactImportanceType;
  onChange: (value: ContactImportanceType) => void;
  disabled?: boolean;
};

const ContactImportanceSelect: React.FC<ContactImportanceSelectProps> = ({
  value,
  onChange,
  disabled,
}) => (
    <Select
      label="Contact Status"
      required
      zIndex={zPositions.contactModalComponents}
      value={value}
      onChange={onChange}
      options={[
        { label: 'Primary', value: 'Primary' },
        { label: '2nd', value: '2nd' },
        { label: '3rd', value: '3rd' },
        { label: 'Other', value: 'Other' },
      ]}
      disabled={disabled}
      data-cy="contact-importance-select"
    />
  );

export default ContactImportanceSelect;
